






















































































































































































































import { fetchConfiguracion } from './fetchConfiguracion';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { EstadoInterface } from '@/interfaces/Estado';
import { LoadingService } from '@/services/loadingService';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import { SubAccion } from '@/views/base/VariablesPermisos';
import HandleErrors from '@/config/handleErrors';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { makeAccionesColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import { Accion } from '@/config/enums';
import { eventBus, actionsEvent } from '@/setup';
import { toUpper } from 'lodash';

@Component({
  components: {
    DatePicker,
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
    MantenedorGrid,
  },
})
export default class CrearAlarma extends ComponenteBaseStepper {
  @Prop({ required: true }) tiposAlarma: Array<Object>;
  @Prop({ required: true }) ubicaciones: Array<Object>;

  funcionalidad: Funcionalidades =
    Funcionalidades.TablaEmailsConfiguracionAlarmas;

  returnUnicos(data: any) {
    let hash: any = {};
    let unicos = data.filter((dato: any) =>
      hash[dato.alarmaemail.toUpperCase()]
        ? false
        : (hash[dato.alarmaemail.toUpperCase()] = true)
    );
    return unicos;
  }

  addEmail() {
    let validEmail = this.rules.email(this.formFields.correo.value);
    if (validEmail !== 'Invalid e-mail.') {
      let dato = {
        alarmaemail: this.formFields.correo.value.toUpperCase(),
      };
      this.ordesList.push(dato);
      let totales = this.ordesList;
      this.ordesList = this.returnUnicos(totales);
      this.gridApi.setRowData(this.ordesList);
      this.gridApi.setDomLayout('autoHeight');
      this.formFields.correo.value = '';
    } else {
      this.$snotify.error('Por favor ingrese un email valido', {
        timeout: 3000,
      });
    }
  }

  rules = {
    required: (value: any) => !!value || 'Required.',
    negativo: (value: any) => value >= 0 || 'Required.',
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      } else {
        return 'Invalid e-mail.';
      }
    },
  };

  cargarTipoValor() {
    let alarma: any = this.tiposAlarma.find(
      (e: any) => e.configid == this.formFields.tipoAlarma.value
    );
    this.formFields.tipoValor.value =
      alarma && alarma.configvalor ? alarma.configvalor : '';
  }

  condiciones: Array<object> = [];
  motivosBaja: Array<object> = [];
  tiposOperacion: Array<object> = [];
  tiposEquipo: Array<object> = [];
  bajaid: string;
  async getOpcionesCrear() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion({}, 'conecta_configuracion_alarmas/get_opciones')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.condiciones = data.data.CONDICIONES;
          this.tiposOperacion = data.data.TIPOSOPERACION;
          this.bajaid = data.data.BAJAID;
          this.motivosBaja = data.data.MOTIVOSBAJA;
          this.tiposEquipo = data.data.TIPOS_EQUI;
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las alarmas', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  alarmaId: number;
  async getSiguienteId() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion({}, 'conecta_configuracion_alarmas/get_alarma_id')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.alarmaId = Number(data.data.data.alarmaid);
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar el id de la alarma', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  mounted() {
    this.getSiguienteId();
    this.getOpcionesCrear();
  }

  async postAlarma() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracion(
      {
        id: this.nuevoDato.id,
        nombre: this.nuevoDato.nombre.toUpperCase(),
        tipoAlarma: this.nuevoDato.tipoAlarma,
        tipoValor: this.nuevoDato.tipoValor,
        ubicacion: this.nuevoDato.ubicacion,
        condicion: this.nuevoDato.condicion,
        valor: this.nuevoDato.valor,
        tipoOperacion: this.nuevoDato.generaOpera
          ? this.formFields.tipoOperacion.value
          : '',
        motivo: this.formFields.motivo.value,
        generaOpera: this.nuevoDato.generaOpera,
        tipoEquipo: this.nuevoDato.tipoEquipo,
        emails: this.ordesList,
        usuarioId: JSON.parse(localStorage.getItem('user')).id,
        clienteId: JSON.parse(localStorage.getItem('user')).clienteDefecto,
      },
      'conecta_configuracion_alarmas/crear_alarma'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.closeModal();
          return;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error(error, {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  nuevoDato: any = {};
  async crearDatoAlarma() {
    this.nuevoDato = {
      id: this.alarmaId,
      nombre: this.formFields.nombre.value,
      tipoAlarma: this.formFields.tipoAlarma.value,
      tipoValor: this.formFields.tipoValor.value,
      ubicacion: this.formFields.ubicacion.value,
      condicion: this.formFields.condicion.value,
      valor: this.formFields.valor.value,
      tipoEquipo: this.formFields.tipoEqui.value,
      generaOpera: this.formFields.generaOpera.value,
    };
    if (Object.values(this.nuevoDato).includes('')) {
      this.$snotify.error('Por favor ingrese los campos obligatorios', {
        timeout: 3000,
      });
      return;
    }
    if (
      this.formFields.generaOpera.value &&
      this.formFields.tipoOperacion.value == ''
    ) {
      this.$snotify.error('Por favor ingrese el tipo de operación', {
        timeout: 3000,
      });
      return;
    }
    await this.postAlarma();
  }

  formFields: {
    nombre: any;
    tipoAlarma: any;
    ubicacion: any;
    condicion: any;
    tipoValor: any;
    valor: any;
    correo: any;
    tipoOperacion: any;
    motivo: any;
    generaOpera: any;
    tipoEqui: any;
  } = {
    nombre: {
      label: 'Nombre (Obligatorio)',
      value: '',
    },
    tipoAlarma: {
      label: 'Tipo Alarma (Obligatorio)',
      value: '',
    },
    ubicacion: {
      label: 'Ubicación (Obligatorio)',
      value: '',
    },
    condicion: {
      label: 'Condición (Obligatorio)',
      value: '',
    },
    tipoValor: {
      label: 'Tipo Valor',
      value: '',
    },
    valor: {
      label: 'Valor (Obligatorio)',
      value: '',
    },
    correo: {
      label: 'Correo',
      value: '',
    },
    tipoOperacion: {
      label: 'Tipo Operación (Obligatorio)',
      value: '',
    },
    motivo: {
      label: 'Motivo (Obligatorio)',
      value: '',
    },
    generaOpera: {
      label: 'Genera Operación',
      value: false,
    },
    tipoEqui: {
      label: 'Tipo Equipo (Obligatorio)',
      value: '',
    },
  };

  // permisos
  permisosActuales: PermisoAccionVm[] = [];

  // Declarar todas las posibles subAcciones
  crearAlarma: PermisoAccionVm = {
    accion: 'Crear - Crear Alarma',
    visible: true,
    step: 1,
    codigoAccionPadre: CodigoAccion.Crear,
  };

  permisosTotales: PermisoAccionVm[] = [this.crearAlarma];

  // Globales
  $snotify: any;
  e1: number = 1;
  dialog: boolean = true;
  validForm: boolean = false;
  loadingService = new LoadingService();
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //data
  estadosServices: EstadosService = new EstadosService();
  estados: EstadoInterface[] = this.estadosServices.getEstadosVisibles();

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  ordesList: any = [];
  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = [];
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  gridOptions: GridOptions;

  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;
  handleErrors: HandleErrors = new HandleErrors();

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  funcionalidades: Array<IFuncionalidad> = [];

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD');
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Email',
        field: 'alarmaemail',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 500,
        width: 500,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      makeAccionesColumnDef(this.funcionalidad),
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD-MM-YYYY');
  }

  closeModal() {
    document.getElementById('cardDivModulos').scrollIntoView(true);
    this.editedItem = {};
    this.e1 = 1;
    this.$emit('modalAsociacionEmit', false);
    this.$validator.reset(); //Reset Validaciones
    this.dialog = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal();
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (
        this.funcionalidad === Funcionalidades.TablaEmailsConfiguracionAlarmas
      ) {
        if (data.action === Accion.Eliminar) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            let indexDelete = this.ordesList.indexOf(
              data.cellRendererParams.data
            );
            this.ordesList.splice(indexDelete, 1);
            this.gridApi.setRowData(this.ordesList);
            this.gridApi.setDomLayout('autoHeight');
          }
        }
      }
    });
  }

  created() {
    this.initialize();
  }
}
